import FaqAccordion from '@/components/feature/FaqAccordion';
import { FAQ_GROUPS } from '@/mocks/faq';

export default function FaqGroups() {
  return (
    <section className="w-full px-4 md:px-6 py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto flex flex-col gap-14 md:gap-20">
        {FAQ_GROUPS.map((g, idx) => (
          <div key={g.id} id={g.id} className="scroll-mt-28 grid grid-cols-1 lg:grid-cols-12 gap-6 lg:gap-10">
            <div className="lg:col-span-4">
              <span className="font-heading text-4xl font-bold text-background-300">
                {String(idx + 1).padStart(2, '0')}
              </span>
              <h2 className="mt-3 font-heading text-xl md:text-2xl font-bold text-foreground-950">{g.title}</h2>
              <p className="mt-3 text-sm text-foreground-600 leading-relaxed">{g.desc}</p>
              <p className="mt-4 text-xs text-foreground-400">共 {g.items.length} 个问题</p>
            </div>
            <div className="lg:col-span-8">
              <FaqAccordion items={g.items} defaultOpenId={g.items[0]?.id} />
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}